const arrow_down = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M19.293%207.293l1.414%201.414L12%2017.414%203.293%208.707l1.414-1.414L12%2014.586z'%20fill-rule='evenodd'/%3e%3c/svg%3e";
export {
  arrow_down as default
};
//# sourceMappingURL=arrow_down.svg.es.js.map
